/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  useCallback,
  useContext,
} from 'react';
import AccountsView from 'screens/Admin/Accounts/components/View';
import useFetchTableData from 'hooks/useFetchTableData';
import InvestmentAccountService from 'services/api/InvestmentAccount';
import AdminContainer from 'components/Admin/AdminContainer';
import { useLocation, useParams } from 'react-router-dom';
import handlePromise from 'utils/Promise';
import { LoadingContext } from 'context/Loading';
import { getFile } from 'utils/downloadBase64';

type SilentOpts = { silent?: boolean };

function Accounts() {
  const { id, type } = useParams();
  const location = useLocation();
  const dataLocation:any = location?.state;
  const { toggleLoading } = useContext( LoadingContext );

  const { fetchData, data, dataLoading } = useFetchTableData( {
    promise: ( params ) => {
      if ( type === 'user' && id ) {
        return InvestmentAccountService.getAllBackOffice( { ...params, contactId: id } );
      }
      if ( type === 'pro' && id ) {
        return InvestmentAccountService.getAllByPromocionBackOffice(
          { ...params, promocionId: id },
        );
      }
      return InvestmentAccountService.getAllBackOffice( params );
    },
    deps: [type],
  } );

  const downloadDocument = useCallback( async ( params: any ) => {
    toggleLoading( true );
    let downloadDocumentData;
    if ( type === 'user' && id ) {
      [, , downloadDocumentData] = await handlePromise(
        InvestmentAccountService.getAllBackOffice( { ...params, contactId: id }, { responseType: 'blob' } ),
      );
    } else if ( type === 'pro' && id ) {
      [, , downloadDocumentData] = await handlePromise(
        InvestmentAccountService.getAllByPromocionBackOffice( { ...params, promocionId: id }, { responseType: 'blob' } ),
      );
    } else {
      [, , downloadDocumentData] = await handlePromise(
        InvestmentAccountService.getAllBackOffice( { ...params }, { responseType: 'blob' } ),
      );
    }

    setTimeout( () => {
      toggleLoading( false );
    }, 800 );

    getFile( downloadDocumentData, 'cuentas-de-inversion' );
  }, [] );

  const sincronizarSolicitudDocAction = useCallback(
    async ( accountId: number, opts: SilentOpts = {} ) => {
      if ( !opts.silent ) toggleLoading( true );
      const solicitudResponse = await InvestmentAccountService.getSincronizarSolicitudDoc(
        Number( accountId ),
      );
      if ( !opts.silent ) toggleLoading( false );
      return solicitudResponse;
    },
    [],
  );

  const getSyncStatusAction = useCallback( async (
    accountId: number,
    opts: { runId?: string; silent?: boolean } = {},
  ) => {
    if ( !opts.silent ) toggleLoading( true );
    const statusResponse = await InvestmentAccountService.getSyncSolicitudDocStatus(
      Number( accountId ),
      opts.runId ? { runId: opts.runId } : {},
    );
    if ( !opts.silent ) toggleLoading( false );
    return statusResponse;
  }, [] );

  const getSyncLogsAction = useCallback( async (
    accountId: number,
    params:any = {},
    opts: SilentOpts = {},
  ) => {
    if ( !opts.silent ) toggleLoading( true );
    const logsResponse = await InvestmentAccountService.getSyncSolicitudDocLogs(
      Number( accountId ),
      params,
    );
    if ( !opts.silent ) toggleLoading( false );
    return logsResponse;
  }, [] );

  let headerTitle = type === 'inv' ? dataLocation?.nameCuentadeInversion : '';
  headerTitle = type === 'user' ? dataLocation?.fullName : headerTitle;
  headerTitle = type === 'pro' ? dataLocation?.codigoPromocion : headerTitle;

  return (
    <AdminContainer
      credentialState={dataLocation?.credentialState}
      ssoUserId={dataLocation?.ssoUserId}
      roles={dataLocation?.roles}
      userId={dataLocation?.userId}
      extraData={dataLocation?.extraData}
      headerTitle={headerTitle}
      type={type}
      id={id ? Number( id ) : undefined}
    >
      <AccountsView
        accounts={data}
        fetchData={fetchData}
        isLoading={dataLoading}
        downloadDocument={downloadDocument}
        sincronizarSolicitudDocAction={sincronizarSolicitudDocAction}
        getSyncStatusAction={getSyncStatusAction}
        getSyncLogsAction={getSyncLogsAction}
        type={type}
      />
    </AdminContainer>
  );
}

export default Accounts;
